// extracted by mini-css-extract-plugin
module.exports = {"clickable":"NavigationChip-module_clickable__2j7AKpk_aHLRe_0AblueZQ"};